import { createFileRoute } from '@tanstack/react-router';
import { DataSettingsPage } from '../features/settings/DataSettingsPage';

export const Route = createFileRoute('/settings/data')({
  component: DataSettingsPage,
});
